<template>
  <form id="loginForm" @submit.prevent="check">
    <label class="text-heading-6 text-primary-1">{{
      t("auth.emailAddress")
    }}</label>
    <input
      ref="textInput"
      name="user-email"
      autocomplete="userEmail"
      class="input-color rounded-[5px] w-full outline-none px-5 py-2 h-10 mt-3"
      :class="[
        { 'border border-red': hasError }
      ]"
      :placeholder="t('auth.email')"
      :disabled="showPasswordInput"
      type="email"
      v-model="email"
    />
    <div v-if="showPasswordInput" class="mt-5">
      <label class="text-heading-6 text-primary-1">{{
        t("auth.password")
      }}</label>
      <div class="relative mt-3">
        <input
          ref="passwordInput"
          v-model="password"
          name="user-password"
          autocomplete="userPassword"
          class="input-color rounded-[5px] w-full outline-none px-5 pe-9 py-2 h-10"
          :class="{ 'border border-red': hasError }"
          :placeholder="t('auth.password')"
          :type="showPasswordValue ? 'text' : 'password'"
          @input="validateInput($event)"
          @blur="setTouched"
        />
        <BaseEyeButton @click="togglePasswordStatus" :show="showPasswordValue" />
      </div>
      <!-- <span
        v-if="password.length < 7 && password.length > 1"
        class="text-red mt-2.5 flex gap-1 items-center"
      >
        <icon-warning class="text-red text-[15px] !mb-0" />
        At least 8 characters
      </span> -->

      <div class="mt-2.5">
        <span
          class="text-heading-6 text-primary-1 underline cursor-pointer"
          @click="goToForgot()"
        >
          {{ t("auth.forgotPassword") }}
        </span>
      </div>
    </div>
    <span
      class="text-[12px] font-normal text-red mt-2.5 flex gap-1 items-center"
    >
      {{ errorMessage }}
    </span>
    <div>
      <BaseButton
        type="primary"
        buttonType="submit"
        :label="t('auth.login')"
        :height="52"
        :loading="checking"
        class="!w-full mt-8"
        @click="check"
        @keyup.enter="check"
      />
      <span
        v-if="error.length > 1 && showPasswordInput"
        class="text-red mt-2.5 block"
      >
        {{ t("auth.incorrectPasswordDescription") }}
      </span>
    </div>
  </form>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { validateEmailFormat } from "../../../composables/helper";
import { EmailStatus } from "../../../utils/enum";
const { t } = useI18n();
const emit = defineEmits([
  "check",
  "close",
  "open-forgot",
  "update:email",
  "update:show-password",
]);
const props = defineProps({
  showPassword: {
    type: Boolean,
    default: false,
  },
});
const { login, checkAccount, error } = useAuth();
const hasError = ref(false);
const checking = ref<boolean>(false);
const showPasswordInput = ref<boolean>(false);
const password = ref<string>("");
const email = ref<string>("");
const errorMessage = ref<string>("");
const showPasswordValue = ref<boolean>(false);

const textInput = ref<HTMLInputElement | null>(null);

function validateInput(event: Event | null = null) {
  return true;
}
function validateEmail() {
  const inputValue = email.value
    ? email.value.trim()
    : textInput.value
      ? textInput.value.value.trim()
      : "";
  if (inputValue && !validateEmailFormat(inputValue)) {
    errorMessage.value = t("auth.formatIsNotCorrect");
    return false;
  } else {
    errorMessage.value = "";
    return true;
  }
}

function setTouched(event: Event) {
  validateInput(event);
}

async function check() {
  if (showPasswordInput.value) return loginUser();
  if (textInput.value) {
    if (validateEmail()) {
      if (validateEmailFormat(textInput.value.value)) {
        hasError.value = false;
        checking.value = true;
        const res = await checkAccount(textInput?.value?.value);
        checking.value = false;
        emit("update:email", email.value);
        if (res) return (showPasswordInput.value = true);
        return emit("check", EmailStatus["not-found"]);
      } else {
        hasError.value = true;
      }
    }
  }
}
watch(
  showPasswordInput,
  (val) => {
    emit("update:show-password", val);
  },
  { immediate: true }
);
watch(
  () => props.showPassword,
  (val) => {
    showPasswordInput.value = props.showPassword;
  },
  { immediate: true }
);
async function loginUser() {
  // if (password.value.length > 6)
  if (textInput.value) {
    if (validateEmailFormat(textInput.value.value)) {
      hasError.value = false;
      checking.value = true;
      const res = await login({
        email: textInput.value.value,
        password: password.value,
      });
      checking.value = false;
      if (res) emit("close");
    } else {
      hasError.value = true;
    }
  }
}

function goToForgot() {
  emit("open-forgot");
}

const togglePasswordStatus = () => {
  showPasswordValue.value = !showPasswordValue.value;
};
</script>
